export default __webpack_public_path__ + "static/media/GM_Bowl_Trippy.ce3eb76e.png";